import React from 'react'

function VersionInfoPage() {
  return <div className="text-white">{import.meta.env.VITE_COMMIT_SHA}</div>
}

export default VersionInfoPage
